var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdd2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1478_84149",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.728516,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1478_84149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 19.7285C11.7167 19.7285 11.4792 19.6327 11.2875 19.441C11.0958 19.2493 11 19.0118 11 18.7285V13.7285H6C5.71667 13.7285 5.47917 13.6327 5.2875 13.441C5.09583 13.2493 5 13.0118 5 12.7285C5 12.4452 5.09583 12.2077 5.2875 12.016C5.47917 11.8243 5.71667 11.7285 6 11.7285H11V6.72852C11 6.44518 11.0958 6.20768 11.2875 6.01602C11.4792 5.82435 11.7167 5.72852 12 5.72852C12.2833 5.72852 12.5208 5.82435 12.7125 6.01602C12.9042 6.20768 13 6.44518 13 6.72852V11.7285H18C18.2833 11.7285 18.5208 11.8243 18.7125 12.016C18.9042 12.2077 19 12.4452 19 12.7285C19 13.0118 18.9042 13.2493 18.7125 13.441C18.5208 13.6327 18.2833 13.7285 18 13.7285H13V18.7285C13 19.0118 12.9042 19.2493 12.7125 19.441C12.5208 19.6327 12.2833 19.7285 12 19.7285Z",
    fill: "#9E9E9E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd2);
export default __webpack_public_path__ + "static/media/add-2.aefb6ae9f1804531e657633c2edba77a.svg";
export { ForwardRef as ReactComponent };